import React from 'react';
import { Route } from 'react-router-dom';
import { combineReducers } from 'redux';

// Reducers
import printQueueReducer from './PrintQueue/store/printQueueReducer';

// Components
import PrintQueueList from './PrintQueue';

// Routes
export const routes = (basePath, permissions) =>
    <Route path={basePath} exact component={PrintQueueList} />;


export const reducers = combineReducers({
    printQueues: printQueueReducer
});